import { render } from "./Settings.vue?vue&type=template&id=53a1d596"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=53a1d596&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.18.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__